import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Пользователи", -1)
const _hoisted_3 = { class: "base-form" }
const _hoisted_4 = { class: "base-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddUserClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новый пользователь ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tableRolesFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableRolesFilter) = $event)),
                multiple: "",
                placeholder: "Фильтр по ролям",
                onChange: _ctx.fetchUsersAsync
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoles, (e) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: e.id,
                      value: e.id,
                      label: e.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createTextVNode("   ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 8,
          style: {"text-align":"right"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearchQuery,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                style: {"max-width":"600px"},
                placeholder: "Поиск по логину, имени, фамилии, отчеству или телефону",
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tableRef",
              "row-key": "id",
              sortable: "custom",
              data: _ctx.tableData,
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onSortChange: _ctx.onTableSortingChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "selection" }),
                _createVNode(_component_el_table_column, {
                  width: "100",
                  label: "№",
                  prop: "id",
                  sortable: "",
                  "column-key": "id"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      onClick: () => _ctx.onTableLoginCellClick(scope.row),
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  label: "Дата создания",
                  prop: "date",
                  sortable: "",
                  "column-key": "id"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.df.dateTime(scope.row.date, true, true)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Логин",
                  prop: "login",
                  sortable: "",
                  "column-key": "login"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      onClick: () => _ctx.onTableLoginCellClick(scope.row),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.login), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("div", null, [
                      (scope.row.blocked)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("заблокирован")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Роли" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.formatRoles(scope.row.roles)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Сотрудник",
                  prop: "employee.lastname",
                  sortable: "",
                  "column-key": "lastname"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: () => _ctx.onTableLoginCellClick(scope.row)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.employee?.lastname) + " " + _toDisplayString(scope.row.employee?.firstname?.substring(0,1)) + ". ", 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Должность, грейд",
                  prop: "vin"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.employee?.position?.name) + " ", 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_text, {
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.employee?.positionGrade?.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { align: "center" }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "danger",
                      onClick: ($event: any) => (_ctx.onDeleteUserClick(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Удалить ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onSortChange"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}